const NS = 'CareerItemWidget';
const CLS = 'careerItemWidget';

import { handleTruncate } from '../../../../global/js/wlc/truncate';

export class CareerItemWidget{
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$contentDesc = this.$element.find(`.${CLS}-desc`);
		handleTruncate(this.$contentDesc, 200);

	}
}
